<template>
  <div class="error form">
    <div class="error__content">
      <template v-if="status === 'dontAllowDirectVisit'">
        <h1 class="jumbo-headline">Hello.</h1>
        <div v-html="text"></div>
      </template>
      <template v-else>
        <h3 class="small-headline">
          (Code: {{ status || "Something went wrong" }})
        </h3>
        <h1 class="jumbo-headline">Oops!</h1>
        <p>{{ text || "" }}</p>
        <ButtonBase @onButtonClick="handleButtonClick">{{
          returnButtonLabel
        }}</ButtonBase>
      </template>
    </div>
  </div>
</template>
<script setup>
import { useTitle } from "@vueuse/core";
import { useRouter } from "vue-router";
import { ref, onMounted, watch } from "vue";

import ButtonBase from "@/components/ui/buttons/ButtonBase.vue";
import { useGlobalStore } from "@/stores/globalStore";

const props = defineProps(["status", "text"]);
const router = useRouter();
const globalStore = useGlobalStore();
const returnButtonLabel = ref("Create a new order");

const handleButtonClick = () => {
  const returnURL = globalStore.getMerchantSettings.returnUrl;
  if (returnURL !== "") {
    window.location = returnURL;
    return;
  }
  router.push("/");
};

watch(
  () => globalStore.getMerchantSettings,
  (val) => {
    if (val && val.returnMessage !== "") {
      returnButtonLabel.value = val.returnMessage;
    }
  },
  { deep: true, immediate: true }
);

onMounted(() => {
  if (props.status !== "dontAllowDirectVisit") {
    useTitle(`Banxa - Code: ${props.status || "Something went wrong!"}`);
  } else {
    useTitle("Something went wrong!");
  }
});
</script>
<style lang="scss" scoped>
.error {
  width: 100%;
  min-height: 25em;
  display: flex;
  justify-content: center;
  align-items: center;

  &__content {
    width: 100%;
    padding: 0 var(--padding-1) 2rem;
    max-width: 50rem;

    h3 {
      color: var(--primary);
      margin-bottom: 0.8rem;
    }

    h1 {
      margin-bottom: 1.6rem;
    }

    p {
      margin-bottom: 3.2rem;
    }
  }
}
</style>
